export const scopeTypes = {
  LOCAL: 'LOCAL',
  GLOBAL: 'GLOBAL',
  IMPORT: 'IMPORT'
}
